import React, { useState, useEffect } from 'react';
import './Clientes.css';
import Header from '../common/Header';
import Footer from '../common/Footer';
import FormModal from '../common/FormModal';
import ConfirmModal from '../common/ConfirmModal';
import FormField from '../common/FormField';
import FormGrid, { FormGridFullWidth } from '../common/FormGrid';
import SearchBar from '../common/SearchBar';
import { useToast } from '../../contexts/ToastContext';
import { getApiUrl } from '../../utils/api';
import { FaSearch, FaSave, FaPlus, FaEdit, FaTrash, FaUser, FaHome, FaPhone, FaIdCard, FaCreditCard, FaStickyNote } from 'react-icons/fa';

const Clientes = () => {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [clienteAEliminar, setClienteAEliminar] = useState(null);

  // Campos del formulario
  const [formData, setFormData] = useState({
    nombre: '',
    calle: '',
    numero: '',
    telefono: '',
    financiamiento: '',
    cp: '',
    rfc: '',
    referencia: ''
  });

  const [filtroNombre, setFiltroNombre] = useState('');
  const toast = useToast();

  useEffect(() => {
    cargarClientes();
  }, []);

  const cargarClientes = async () => {
    try {
      setLoading(true);
      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tipo: 'getClientes'
        })
      });

      const data = await response.json();

      if (data.success) {
        setClientes(data.data || []);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Error al cargar clientes:', error);
      toast.error('Error al cargar clientes');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const nuevoCliente = () => {
    setFormData({
      nombre: '',
      calle: '',
      numero: '',
      telefono: '',
      financiamiento: '',
      cp: '',
      rfc: '',
      referencia: ''
    });
    setClienteSeleccionado(null);
    setShowModal(true);
  };

  const editarCliente = (cliente) => {
    setFormData({
      nombre: cliente.nombre || '',
      calle: cliente.calle || '',
      numero: cliente.numero || '',
      telefono: cliente.telefono || '',
      financiamiento: cliente.financiamiento || '',
      cp: cliente.cp || '',
      rfc: cliente.rfc || '',
      referencia: cliente.referencia || ''
    });
    setClienteSeleccionado(cliente);
    setShowModal(true);
  };

  const guardarCliente = async () => {
    try {
      setGuardando(true);

      if (!formData.nombre.trim()) {
        toast.error('El nombre del cliente es obligatorio');
        return;
      }

      const endpoint = clienteSeleccionado ? 'actualizarCliente' : 'crearCliente';
      const payload = {
        tipo: endpoint,
        ...formData
      };

      if (clienteSeleccionado) {
        payload.idCliente = clienteSeleccionado.idCliente;
      }

      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (data.success) {
        toast.success(clienteSeleccionado ? 'Cliente actualizado correctamente' : 'Cliente creado correctamente');
        handleCloseModal();
        cargarClientes();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Error al guardar cliente:', error);
      toast.error('Error al guardar cliente');
    } finally {
      setGuardando(false);
    }
  };

  const confirmarEliminarCliente = (cliente) => {
    setClienteAEliminar(cliente);
    setShowDeleteModal(true);
  };

  const eliminarCliente = async () => {
    if (!clienteAEliminar) return;

    try {
      setGuardando(true);
      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tipo: 'eliminarCliente',
          idCliente: clienteAEliminar.idCliente
        })
      });

      const data = await response.json();

      if (data.success) {
        toast.success('Cliente eliminado correctamente');
        setShowDeleteModal(false);
        setClienteAEliminar(null);
        cargarClientes();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Error al eliminar cliente:', error);
      toast.error('Error al eliminar cliente');
    } finally {
      setGuardando(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setClienteSeleccionado(null);
    setFormData({
      nombre: '',
      calle: '',
      numero: '',
      telefono: '',
      financiamiento: '',
      cp: '',
      rfc: '',
      referencia: ''
    });
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setClienteAEliminar(null);
  };

  // Filtrar clientes
  const clientesFiltrados = clientes.filter(cliente => {
    return cliente.nombre && cliente.nombre.toLowerCase().includes(filtroNombre.toLowerCase());
  });

  if (loading) {
    return (
      <div className="clientes-container">
        <div className="loading">Cargando clientes...</div>
      </div>
    );
  }

  return (
    <div className="clientes-container">
      <Header
        titulo='Clientes'
        color='#667eea'
      />
      <div className="clientes-content">
        <div className="clientes-inner">
          <div className="clientes-header">
            <h1 className="clientes-titulo">Catálogo de Clientes</h1>
            <div className="botones-header">
              <button
                onClick={nuevoCliente}
                className="btn-nuevo"
              >
                <FaPlus /> Nuevo Cliente
              </button>
            </div>
          </div>


          <div className="panel-filtros">
            <div className="filtros-content">
              <div className="filtros-row-horizontal">
                <div className="filtro-item">
                  <label>Búsqueda de Clientes</label>
                </div>

                <div className="filtro-boton-buscar">
                  <SearchBar
                    value={filtroNombre}
                    onChange={(e) => setFiltroNombre(e.target.value)}
                    placeholder="Buscar por nombre..."
                    size="medium"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="panel-listado">
            <div className="tabla-container">
              {loading ? (
                <div className="cargando">Cargando clientes...</div>
              ) : clientesFiltrados.length === 0 ? (
                <div className="sin-datos">No se encontraron clientes.</div>
              ) : (
                <table className="tabla-clientes">
                  <thead>
                    <tr>
                      <th>Nombre</th>
                      <th>Teléfono</th>
                      <th>Calle</th>
                      <th>#</th>
                      <th>Financiamiento</th>
                      <th>CP</th>
                      <th>RFC</th>
                      <th>Referencia</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {clientesFiltrados.map(cliente => (
                      <tr key={cliente.idCliente}>
                        <td className="nombre-cliente">{cliente.nombre}</td>
                        <td>{cliente.telefono}</td>
                        <td>{cliente.calle}</td>
                        <td>{cliente.numero}</td>
                        <td>{cliente.financiamiento}</td>
                        <td>{cliente.cp}</td>
                        <td>{cliente.rfc}</td>
                        <td className="referencia">{cliente.referencia}</td>
                        <td>
                          <div className="acciones-cliente">
                            <button
                              onClick={() => editarCliente(cliente)}
                              className="btn-accion btn-editar"
                              title="Editar cliente"
                            >
                              <FaEdit />
                            </button>
                            <button
                              onClick={() => confirmarEliminarCliente(cliente)}
                              className="btn-accion btn-eliminar"
                              title="Eliminar cliente"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            <div className="acciones-container">
              <div className="info-clientes">
                <span>Total de clientes: {clientesFiltrados.length}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />

      {/* Modal para crear/editar cliente */}
      <FormModal
        isOpen={showModal}
        onClose={handleCloseModal}
        title={clienteSeleccionado ? 'Editar Cliente' : 'Nuevo Cliente'}
        onSave={guardarCliente}
        saveLabel={clienteSeleccionado ? 'Actualizar' : 'Crear'}
        isSaving={guardando}
        size="large"
        saveIcon={<FaUser />}
      >
        <FormGrid columns={2} gap="16px">
          <FormField
            label="Nombre"
            name="nombre"
            value={formData.nombre}
            onChange={handleInputChange}
            placeholder="Nombre del cliente"
            required
            icon={<FaUser />}
          />

          <FormField
            label="Teléfono"
            type="tel"
            name="telefono"
            value={formData.telefono}
            onChange={handleInputChange}
            placeholder="Número de teléfono"
            icon={<FaPhone />}
          />

          <FormField
            label="Calle"
            name="calle"
            value={formData.calle}
            onChange={handleInputChange}
            placeholder="Nombre de la calle"
            icon={<FaHome />}
          />

          <FormField
            label="Número"
            name="numero"
            value={formData.numero}
            onChange={handleInputChange}
            placeholder="Número exterior"
          />

          <FormField
            label="C.P."
            name="cp"
            value={formData.cp}
            onChange={handleInputChange}
            placeholder="Código postal"
          />

          <FormField
            label="RFC"
            name="rfc"
            value={formData.rfc}
            onChange={handleInputChange}
            placeholder="RFC del cliente"
            icon={<FaIdCard />}
          />

          <FormGridFullWidth>
            <FormField
              label="Financiamiento"
              name="financiamiento"
              value={formData.financiamiento}
              onChange={handleInputChange}
              placeholder="Información de financiamiento"
              icon={<FaCreditCard />}
            />
          </FormGridFullWidth>

          <FormGridFullWidth>
            <FormField
              label="Referencia"
              type="textarea"
              name="referencia"
              value={formData.referencia}
              onChange={handleInputChange}
              placeholder="Referencias adicionales"
              rows={3}
              icon={<FaStickyNote />}
            />
          </FormGridFullWidth>
        </FormGrid>
      </FormModal>

      {/* Modal de confirmación para eliminar */}
      <ConfirmModal
        isOpen={showDeleteModal}
        onClose={handleCloseDeleteModal}
        onConfirm={eliminarCliente}
        title="Eliminar Cliente"
        message={`¿Está seguro de eliminar al cliente "${clienteAEliminar?.nombre}"? Esta acción no se puede deshacer.`}
        confirmLabel="Eliminar"
        type="danger"
        isLoading={guardando}
      />
    </div>
  );
};

export default Clientes;